export default __webpack_public_path__ + "2b3e1faf89.png";